/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { DosespotPayer } from "./DosespotPayer";
import type { DosespotPrescriptionDetails } from "./DosespotPrescriptionDetails";

export interface DosespotMedication {
  patient_vendor_medication_history_id: number;
  prescription_details: DosespotPrescriptionDetails;
  payer?: DosespotPayer | null;
  diagnosis_code?: string | null;
  diagnosis_qualifier?: string | null;
  expiration_date?: string | null;
}
